import { render, staticRenderFns } from "./alarmView.vue?vue&type=template&id=0b8a2f31&scoped=true&"
import script from "./alarmView.vue?vue&type=script&lang=js&"
export * from "./alarmView.vue?vue&type=script&lang=js&"
import style0 from "./alarmView.vue?vue&type=style&index=0&id=0b8a2f31&prod&lang=scss&scoped=true&"
import style1 from "./alarmView.vue?vue&type=style&index=1&id=0b8a2f31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a2f31",
  null
  
)

export default component.exports